/**
 * Canonical origin for auth (login, signup, reset, Supabase email links).
 * Production builds MUST set VITE_PUBLIC_APP_ORIGIN (e.g. https://usefastsell.com).
 */
export function getAuthAppOrigin(): string {
  const raw = (import.meta.env.VITE_PUBLIC_APP_ORIGIN as string | undefined)?.trim();
  const normalized = raw?.replace(/\/$/, "") ?? "";

  if (import.meta.env.DEV) {
    if (normalized) {
      console.debug("[auth] VITE_PUBLIC_APP_ORIGIN →", normalized);
    } else {
      console.debug(
        "[auth] VITE_PUBLIC_APP_ORIGIN unset — using window.location.origin in development only"
      );
    }
  }

  if (import.meta.env.PROD) {
    if (!normalized) {
      throw new Error(
        "[auth] VITE_PUBLIC_APP_ORIGIN is required in production. " +
          "Set it to your main app URL (no trailing slash), e.g. https://usefastsell.com"
      );
    }
    return normalized;
  }

  if (normalized) return normalized;
  if (typeof window !== "undefined") return window.location.origin.replace(/\/$/, "");
  return "";
}
